export default __webpack_public_path__ + "static/media/icon-info-regular.64cc1229.svg";